export function getDistanceInMiles(lat1, lng1, lat2, lng2){
    // Helper function for distance in miles
    const point1 = new google.maps.LatLng(lat1, lng1);
    const point2 = new google.maps.LatLng(lat2, lng2);
    const meters = google.maps.geometry.spherical.computeDistanceBetween(point1, point2);
    return meters / 1609.34; // Convert meters to miles
          
}